import { useEffect, useState } from "react";
import axios from "axios";
import { Send, MessageCircle, Smartphone, Phone, Mail } from "lucide-react";
import { PainelSMS } from "./sms";
import { NovaCampanhaWhatsApp, PainelWhatsApp } from "./whatsapp";

/**
 * IMPULSIONE SUAS VENDAS → Disparos em massa.
 *
 * SMS e LIGACAO ativos. WhatsApp (API oficial) fica liberado POR LOJA pelo setting
 * `whatsapp_disparo_disponivel` (padrao desligado) — isolamento enquanto a API
 * oficial nao sai pra todos e o App Review nao e' aprovado. Sem o flag, o card
 * segue "EM BREVE". Email EM BREVE.
 */
const auth = () => {
  const token = localStorage.getItem("token");
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export default function DisparosPage() {
  const [canal, setCanal] = useState("sms");
  const [whatsappLiberado, setWhatsappLiberado] = useState(false);
  // Campanha de WhatsApp aberta = página inteira no lugar do painel.
  const [campanhaWa, setCampanhaWa] = useState(null);

  useEffect(() => {
    axios.get("/api/company/settings", auth())
      .then((r) => {
        const v = r.data?.whatsapp_disparo_disponivel;
        setWhatsappLiberado(v === true || v === "1" || v === "true");
      })
      .catch(() => {});
  }, []);

  const canais = [
    { id: "sms", rotulo: "SMS", icone: Smartphone, ativo: true },
    { id: "voz", rotulo: "Ligação", icone: Phone, ativo: true },
    { id: "whatsapp", rotulo: "WhatsApp", icone: MessageCircle, ativo: whatsappLiberado },
    { id: "email", rotulo: "Email", icone: Mail, ativo: false },
  ];

  const abrirCampanhaWa = (modo) => { setCampanhaWa(modo); window.scrollTo?.(0, 0); };
  if (campanhaWa) {
    return <NovaCampanhaWhatsApp modoInicial={campanhaWa} onVoltar={() => setCampanhaWa(null)} />;
  }

  return (
    <div className="p-4 sm:p-6 space-y-5 w-full">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Send className="w-6 h-6 text-primary" />
          <h1 className="text-2xl sm:text-3xl font-bold">Disparos em massa</h1>
        </div>
        <p className="text-muted-foreground">
          Mande uma mensagem pra sua base de clientes e acompanhe quanto ela trouxe de volta em vendas.
        </p>
      </div>

      {/* Celular (25/10/2026): a pílula não quebra em 3 linhas — rola de lado */}
      <div className="flex sm:justify-center overflow-x-auto scrollbar-hide -mx-4 px-4 sm:mx-0 sm:px-0">
        <div className="flex flex-nowrap shrink-0 sm:justify-center gap-1 sm:gap-2 rounded-full border bg-card/60 p-1.5 shadow-sm">
          {canais.map(({ id, rotulo, icone: Icone, ativo }) =>
            ativo ? (
              <button key={id} onClick={() => setCanal(id)}
                className={`inline-flex items-center gap-2 whitespace-nowrap shrink-0 rounded-full px-4 sm:px-5 py-2 text-sm font-semibold transition-colors ${
                  canal === id ? "bg-primary text-primary-foreground shadow" : "hover:bg-muted"}`}>
                <Icone className="w-4 h-4" /> {rotulo}
              </button>
            ) : (
              <span key={id} aria-disabled="true"
                className="inline-flex items-center gap-2 whitespace-nowrap shrink-0 rounded-full px-3 sm:px-4 py-2 text-sm font-medium text-muted-foreground/70 cursor-not-allowed select-none">
                <Icone className="w-4 h-4" /> {rotulo}
                <span className="rounded-full bg-muted px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                  Em breve
                </span>
              </span>
            )
          )}
        </div>
      </div>

      {canal === "whatsapp" ? <PainelWhatsApp onAbrirCampanha={abrirCampanhaWa} /> : <PainelSMS canal={canal} />}
    </div>
  );
}
